import Profile from "~/repository/models/Profile"
import Post from "~/repository/models/Post"
import type {Ref} from "vue";

export const useProfileAPI = (profile: Ref<Profile> | undefined = undefined) => {
    const {$api} = useNuxtApp();

    async function fetch<T extends Profile>(username: string): Promise<T> {
        return await $api.profile.get(username, {
            transform: (data) => new Profile(data)
        })
    }

    async function edit(username: string, name: string, bio: string | undefined) {
        return await $api.profile.edit(username, name, bio)
    }

    async function updateAvatar(mediaId: string) {
        if (!profile) return

        const data = await $api.profile.updateAvatar(mediaId)
        profile.value.avatar = data.avatar
        return data
    }

    function usePurchasedPostsFetch() {
        const fetching = ref<Boolean>(false);
        const posts = ref<{ [key: number]: Post }>({});
        const lastPage = ref(0);

        const fetch = async () => {
            fetching.value = true;
            const paginatedData = await $api.profile.getPurchasedPosts();

            posts.value = {
                ...posts.value,
                ...groupById(paginatedData.data, (id) => id),
            };

            lastPage.value = paginatedData.meta.last_page;
            fetching.value = false;

            return paginatedData;
        };

        return {
            fetching,
            fetch,
            lastPage,
            posts,
        };
    }


    return {
        fetch,
        edit,
        updateAvatar,

        //composable
        usePurchasedPostsFetch
    }
}